// extracted by mini-css-extract-plugin
export default {"grid":"TwoColumnGrid_grid__rwL3g"};